<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    waiting: {
      type: Boolean,
      default: false,
      required: false,
    },
    lite: {
      type: Boolean,
      default: false,
      required: false,
    },
    isControl: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    toggleEvent() {
      if (this.disabled || this.waiting) return;
      this.$emit("input", !this.value);
    },
  },
  computed: {
    message() {
      return this.value ? "Finalizado" : "Marcar como finalizado";
    },
  },
};
</script>
<template>
  <button
    :class="{ checked: this.value, disabled: disabled, waiting: waiting }"
    class="check-button"
    @click="toggleEvent"
  >
    <span v-show="value && !waiting">
      <i class="fas fa-check"></i>
    </span>
    <span v-show="!value && !waiting">
      <i v-if="!isControl" class="far fa-clock"></i>
      <i v-else class="fas fa-xmark"></i>
    </span>
    <span v-show="waiting" class="mr-1">
      <i class="fas fa-spinner fa-spin"></i>
    </span>
    <span v-if="!lite">
      {{ message }}
    </span>
  </button>
</template>
<style scoped>
/* Los estilos ahora están estandarizados en _lego-control-buttons.scss */
</style>
